module.exports = "<p>\r\n  promesas works!\r\n</p>\r\n"